import { 
  applyActionCode, 
  verifyPasswordResetCode,
  confirmPasswordReset,
  checkActionCode,
  auth
} from '../lib/firebase';
import type { EmailActionState } from '../types/auth';

export async function handleEmailAction(
  actionCode: string,
  mode: string | null
): Promise<EmailActionState> {
  try {
    switch (mode) {
      case 'resetPassword':
        // Verify the password reset code
        await verifyPasswordResetCode(auth, actionCode);
        return {
          status: 'resetPassword',
          mode: 'resetPassword',
          message: 'Bitte legen Sie ein neues Passwort fest.'
        };

      case 'recoverEmail':
        const info = await checkActionCode(auth, actionCode);
        // Restore the user's email
        await applyActionCode(auth, actionCode);
        return {
          status: 'success',
          mode: 'recoverEmail',
          message: `Ihre E-Mail-Adresse wurde wiederhergestellt: ${info.data.email}`
        };

      case 'verifyEmail':
        // Apply the email verification code
        await applyActionCode(auth, actionCode);
        return {
          status: 'success',
          mode: 'verifyEmail',
          message: 'Ihre E-Mail-Adresse wurde erfolgreich verifiziert.'
        };

      default:
        return {
          status: 'error',
          mode,
          message: 'Ungültige Aktion'
        };
    }
  } catch (error: any) {
    console.error('Error handling email action:', error);
    
    let message = 'Ein Fehler ist aufgetreten';
    
    switch (error.code) {
      case 'auth/expired-action-code':
        message = 'Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen an.';
        break;
      case 'auth/invalid-action-code':
        message = 'Dieser Link ist ungültig. Möglicherweise wurde er bereits verwendet.';
        break;
      case 'auth/user-disabled':
        message = 'Dieses Konto wurde deaktiviert.';
        break;
      case 'auth/user-not-found':
        message = 'Benutzer nicht gefunden.';
        break;
    }

    return {
      status: 'error',
      mode,
      message
    };
  }
}
